import {start_api} from "../api_services/start_api";
import {stop_api} from "../api_services/stop_api";
import React, {useState} from "react";


export const StartStop = ({ onToggle }) => {

    const [directions, setDirections] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const onStart = async () => {
        setLoading(true);
        try {
            const response = await start_api();
            setMessage(response.message);
            setDirections(prev => [...prev, response]);
            onToggle(true);

        } catch (error) {
            console.error("Failed to start process:", error);
        } finally {
            setLoading(false);
        }
    };

    const onStop = async () => {
        setLoading(true);
        try {
            const response = await stop_api();
            setMessage(response.message);
            setDirections(prev => [...prev, response]);
            onToggle(false);
        } catch (error) {
            console.error("Failed to stop process:", error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className={`flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4`}>
            <button
                onClick={onStart}
                className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg shadow transition duration-200 w-full sm:w-auto"
                disabled={loading}
            >
                {loading ? (
                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" fill="currentColor"/>
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                ) : "▶️ Start"}
            </button>

            <button
                onClick={onStop}
                className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg shadow transition duration-200 w-full sm:w-auto"
                disabled={loading}
            >
                {loading ? (
                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" fill="currentColor"/>
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                ) : "⏹️ Clear"}
            </button>

            {message && (
                <p className="mt-4 text-white">{message}</p>
            )}
        </div>
    );
};
